/* eslint-disable no-console */
/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Edit Plan</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>Title</label>
                        <input type="text" ref="title" :value="plan.title" class="form-control mb-4" placeholder="Title">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Price</label>
                        <input type="number" ref="price" :value="plan.price" class="form-control mb-4" placeholder="Price">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Duration</label>
                        <input type="number" :value="plan.duration" ref="duration" class="form-control mb-4" placeholder="Duration">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Target</label>
                        <select class="form-control mb-4" ref="target" v-model="planTarget">
                            <option value="STUDENT">STUDENT</option>
                            <option value="TEACHER">TEACHER</option>
                        </select>
                    </div>
                </div>

                <!-- Sign in button -->
                <button class="btn btn-info btn-block my-4" @click.prevent="updatePlan()">Update Plan</button>

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'EditPlan',
    components: {

    },
    data() {
        return {
            plan_id: this.$route.params.planId,
            fastAdminToken : localStorage.getItem("fastAdminToken"),
            plan:[],
            planTarget :"",
        }
    },
    methods: {
        updatePlan() {
            let data = {
                price: parseInt(this.$refs.price.value),
                title: this.$refs.title.value,
                duration: parseInt(this.$refs.duration.value),
                target: this.$refs.target.value
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }
            this.$toast.open({
                message: "Processing : Updating Plan Please Wait...",
                type: 'info'
            })
            axios.post(this.$apiURI + "/plan/" + this.plan_id + "/update", data, config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$toast.open({
                            message: "Plan Updated Successfully",
                            type: 'success'
                        })
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        }
    },
    mounted(){
        this.$toast.open({
            message: "Processing : Loading Plan Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        axios.get(this.$apiURI + "/plans/"+this.plan_id, config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.plan = response.data.data
                    this.planTarget = response.data.data.target
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    }

}
</script>
